import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

const solutionKeys = [
  { key: 'caisse', icon: '\uD83D\uDCBB' },
  { key: 'borne', icon: '\uD83D\uDDC3\uFE0F' },
  { key: 'qrcode', icon: '\uD83D\uDCF1' },
  { key: 'serveur', icon: '\uD83E\uDD35' },
  { key: 'cuisine', icon: '\uD83D\uDC68\u200D\uD83C\uDF73' },
  { key: 'orb', icon: '\uD83D\uDCDF' },
  { key: 'livraison', icon: '\uD83D\uDEF5' },
  { key: 'erp', icon: '\uD83D\uDCE6' },
  { key: 'fidelite', icon: '\uD83C\uDFC6' },
  { key: 'stats', icon: '\uD83D\uDCCA' },
  { key: 'siteweb', icon: '\uD83C\uDF10' },
  { key: 'cloud', icon: '\u2601\uFE0F' },
];

export default function Solutions() {
  const { t } = useLanguage();

  return (
    <section className="solutions section" id="solutions">
      <div className="container">
        <h2 className="section-title">{t('solutions.title')}</h2>
        <p className="section-subtitle">{t('solutions.subtitle')}</p>
        <div className="solutions-grid">
          {solutionKeys.map(({ key, icon }) => (
            <div className="solution-card" key={key}>
              <div className="solution-icon">{icon}</div>
              <h3>{t(`solutions.${key}.name`)}</h3>
              <p>{t(`solutions.${key}.desc`)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
